import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
// Components
import Icon from "../../elements/icon";
import Link from "../../elements/link";
// Styles
import "./style.scss";
import { MathUtils } from "../../utils";
import { S_LANG, webStorage } from "../../utils/webStorage";

const CartItem = ({
  name,
  image,
  price,
  discountedPrice,
  link = { url: "" },
  details = [],
  quantity,
  usableStock,
  showLarge = false,
  changeQuantityCallback,
  removeCallback,
  onClick,
  categories, // for anlytics used in callback in parent
  brandName, // for anlytics used in callback in parent
  match
}) => {
  const lang = webStorage.get(S_LANG);
  const trashIcon = '<svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9zm7.5-5l-1-1h-5l-1 1H5v2h14V4z"/></svg>';

  const plusIcon = '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" /></svg>';
  const minusIcon = '<svg style="width:24px;height:24px" viewBox="0 0 24 24"><path fill="currentColor" d="M19,13H5V11H19V13Z" /></svg>';

  const largeItem = {
    "item-large": showLarge
  };
  let isDisabled = quantity >= 20 || usableStock <= quantity;

  return (
    <div className={classNames("cart-item", largeItem)}>
      <div className={classNames("product-image", largeItem)}>
        {link.url && (
          <Link {...link}>
            <img {...image} onClick={onClick} />
          </Link>
        )}
        {!link.url && <img {...image} onClick={onClick} />}
      </div>

      <span className="product-info-container">
        {link.url && (
          <Link {...link} className={classNames("product-name", largeItem)}>
            {name}
          </Link>
        )}
        {!link.url ? name : ""}
        <ul className={classNames("product-info-list", largeItem)}>
          {details.map(detail => {
            if (detail?.value)
              return (
                <li id={detail} key={detail?.title}>
                  <span className="detail-title">{detail?.title + " "}</span>
                  <span>{detail?.value}</span>
                </li>
              );
          })}
        </ul>
      </span>
      <div
        className={classNames("product-widgets-container", {
          "product-widgets-bottom": changeQuantityCallback || removeCallback
        })}
      >
        {changeQuantityCallback && (
          <span className="item-count">
            <button className="cart-button" onClick={() => changeQuantityCallback(-1)}>
              <Icon svg={minusIcon} />
            </button>
            <span>{quantity}</span>
            <button
              className={classNames("cart-button", {
                disable: isDisabled
              })}
              onClick={() => !isDisabled && changeQuantityCallback(+1)}
            >
              <Icon svg={plusIcon} />
            </button>
          </span>
        )}
        <span className="widgets-end">
          {Math.round(discountedPrice) < Math.round(price) ? (
            <span className="product-price">
              <div className="price">{MathUtils.priceFormat(discountedPrice, lang)}</div>
              <div className="discount">{MathUtils.priceFormat(price, lang)}</div>
            </span>
          ) : (
            <span className="price">{MathUtils.priceFormat(price, lang)}</span>
          )}
          {removeCallback && (
            <button className="cart-button" onClick={() => removeCallback(name)}>
              <Icon svg={trashIcon} className="trash-icon" />
            </button>
          )}
        </span>
      </div>
    </div>
  );
};

CartItem.propTypes = {
  name: PropTypes.string,
  image: PropTypes.object,
  price: PropTypes.any,
  discountedPrice: PropTypes.any,
  link: PropTypes.object,
  details: PropTypes.array,
  quantity: PropTypes.number,
  showLarge: PropTypes.bool,
  changeQuantityCallback: PropTypes.func,
  removeCallback: PropTypes.func,
  onClick: PropTypes.func
};

export default CartItem;
